"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WasfatyPrescriptionRequest_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Patient_1 = require("./Patient");
var WasfatyPrescriptionRequest_Factory = /** @class */ (function () {
    function WasfatyPrescriptionRequest_Factory() {
    }
    WasfatyPrescriptionRequest_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Patient: Patient_1.Patient_Factory.CreateIncoming(model.Patient),
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RequestBody: model.RequestBody,
            RequestDate: Date_Factory_1.Date_Factory.CreateIncoming(model.RequestDate),
            SuccessfulRequest: model.SuccessfulRequest,
        };
        return result;
    };
    WasfatyPrescriptionRequest_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Patient: Patient_1.Patient_Factory.CreateOutgoing(model.Patient),
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RequestBody: model.RequestBody,
            RequestDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.RequestDate),
            SuccessfulRequest: model.SuccessfulRequest,
        };
        return result;
    };
    return WasfatyPrescriptionRequest_Factory;
}());
exports.WasfatyPrescriptionRequest_Factory = WasfatyPrescriptionRequest_Factory;
